/**
 * Kabinentypen und Kabinenkategorien
 */

export type SearchBarCabinTypeId =
  | 'Balcony'
  | 'Outside'
  | 'Interior'
  | 'Single'
  | 'Family'
  | 'Veranda'
  | 'JuniorSuite'
  | 'Suite';

export const SEARCH_BAR_CABIN_TYPE_ORDER: readonly SearchBarCabinTypeId[] = [
  'Balcony',
  'Outside',
  'Interior',
  'Single',
  'Family',
  'Veranda',
  'JuniorSuite',
  'Suite',
];

type CabinCategoryCodes_Balcony = 'BA' | 'BK' | 'BS';
type CabinCategoryCodes_Outside = 'AU';
type CabinCategoryCodes_Interior = 'IN';
type CabinCategoryCodes_Single = 'EA' | 'EB' | 'EI';
type CabinCategoryCodes_Family = 'FA' | 'FB' | 'FD' | 'FV';
type CabinCategoryCodes_Veranda = 'VE' | 'VP';
type CabinCategoryCodes_JuniorSuite = 'JB' | 'JV';
type CabinCategoryCodes_Suite =
  | 'SA'
  | 'SD'
  | 'SF'
  | 'SG'
  | 'SH'
  | 'SM'
  | 'SP'
  | 'ST'
  | 'SU'
  | 'SV'
  | 'SW';

type CabinCategoryCodes =
  | CabinCategoryCodes_Balcony
  | CabinCategoryCodes_Outside
  | CabinCategoryCodes_Interior
  | CabinCategoryCodes_Single
  | CabinCategoryCodes_Family
  | CabinCategoryCodes_Veranda
  | CabinCategoryCodes_JuniorSuite
  | CabinCategoryCodes_Suite;

export type CabinTypeDefinition = {
  id: SearchBarCabinTypeId;
  label: string;
  categories: readonly CabinCategoryCodes[];
};

export const CABIN_TYPE_DEFINITIONS: readonly CabinTypeDefinition[] = [
  {
    id: 'Balcony',
    label: 'Balkonkabine',
    categories: ['BA', 'BK', 'BS'],
  },
  {
    id: 'Outside',
    label: 'Außenkabine',
    categories: ['AU'],
  },
  {
    id: 'Interior',
    label: 'Innenkabine',
    categories: ['IN'],
  },
  {
    id: 'Single',
    label: 'Einzelkabine',
    categories: ['EA', 'EB', 'EI'],
  },
  {
    id: 'Family',
    label: 'Familienkabine',
    categories: ['FA', 'FB', 'FD', 'FV'],
  },
  {
    id: 'Veranda',
    label: 'Verandakabine',
    categories: ['VE', 'VP'],
  },
  {
    id: 'JuniorSuite',
    label: 'Junior Suite',
    categories: ['JB', 'JV'],
  },
  {
    id: 'Suite',
    label: 'Suite',
    categories: [
      'SA',
      'SD',
      'SF',
      'SG',
      'SH',
      'SM',
      'SP',
      'ST',
      'SU',
      'SV',
      'SW',
    ],
  },
];

export const getCategoriesForCabinType = (
  id: string,
): readonly CabinCategoryCodes[] =>
  CABIN_TYPE_DEFINITIONS.find(d => d.id === id)?.categories ?? [];

export const canSelectSingleCabin = (
  adults: number,
  children: number,
): boolean => adults === 1 && children === 0;
